import { SharedService } from '@flowaccount/landing'
import { TranslateService } from '@ngx-translate/core'
import { ActivatedRoute } from '@angular/router'
import { Title } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
import { ViewChild, HostListener, Directive } from '@angular/core'
import { SwiperDirective } from 'ngx-swiper-wrapper'

@Directive()
export abstract class DownloadpdfComponent {
  public index: any
  public config: any
  @ViewChild(SwiperDirective, { static: true }) directiveRef?: SwiperDirective
  constructor(
    protected sharedService: SharedService,
    public translate: TranslateService,
    protected activatedRoute: ActivatedRoute,
    protected titleService: Title,
    protected seoService: SEOService,
  ) {}

  onAppear() {}
}
